import React from "react";
import PostExcerpt from "./PostExcerpt.jsx";
import Grid from "react-bootstrap/lib/Grid";
import Row from "react-bootstrap/lib/Row";
import Col from "react-bootstrap/lib/Col";

import styles from "./styles/Posts.module.scss";


const Posts = ({posts}) => {

	return (
    <div className={styles.PostsContainer}>

      <Grid className={styles.PostListingPage}>
        <Row>
        {
          posts.map((post) => {
            return (
              <Col xs={12} key={post.id}>
                <PostExcerpt post={post} />
              </Col>
            );
          })
        }
        </Row>
      </Grid>

    </div>
  );

}

export default Posts;
